import React from "react";
import { ExpendableLink } from "./expendable-link";
import {
  Blocks,
  LayoutDashboard,
  Package,
  User,
  Building2,
  MapPin,
  Contact2,
  CalendarCheck,
  ShoppingCart,
  BadgeCheck,
  Tags,
  ListChecks,
  Warehouse,
  Boxes,
  ScanLine,
  QrCode,
  Gift,
  Megaphone,
  Mail,
  Settings,
  Bell,
} from "lucide-react";

export const AdminMenu: React.FC = () => {
  return (
    <>
      <ExpendableLink
        url="/"
        title="Dashboard"
        icon={<LayoutDashboard size={18} />}
      />

      <ExpendableLink
        title="Mes tâches"
        url="/tasks"
        icon={<ListChecks size={18} />}
      />

      <ExpendableLink
        title="Clients"
        url="/customers"
        icon={<Building2 size={18} />}
      />

      <ExpendableLink
        title="Produits"
        url="/products"
        icon={<Package size={18} />}
      />

      <ExpendableLink
        title="Utilisateurs"
        url="/users"
        icon={<User size={18} />}
      />
      <ExpendableLink
        icon={<Blocks size={18} />}
        title="Categories"
        url="/categories"
      />

      <ExpendableLink
        title="Adresses"
        url="/customer-addresses"
        icon={<MapPin size={18} />}
      />

      <ExpendableLink
        title="Contacts"
        url="/contacts"
        icon={<Contact2 size={18} />}
      />

      <ExpendableLink
        title="Postes"
        url="/job-titles"
        icon={<BadgeCheck size={18} />}
      />

      <ExpendableLink
        title="Visites"
        url="/visits"
        icon={<CalendarCheck size={18} />}
      />

      <ExpendableLink
        title="Commandes"
        url="/orders"
        icon={<ShoppingCart size={18} />}
      />

      <ExpendableLink
        title="Règles de prix"
        url="/price-rules"
        icon={<Tags size={18} />}
      />

      <ExpendableLink
        title="Distributions gratuites"
        url="/given-cans"
        icon={<Gift size={18} />}
      />

      <ExpendableLink
        title="Prospections"
        url="/prospections"
        icon={<Megaphone size={18} />}
      />

      <ExpendableLink
        title="Notifications"
        url="/notifications"
        icon={<Bell size={18} />}
      />

      <ExpendableLink
        title="Emails"
        url="/mail-messages"
        icon={<Mail size={18} />}
      />

      <ExpendableLink
        title="Ma boite mail"
        url="/my-mailbox"
        icon={<Settings size={18} />}
      />

      <ExpendableLink
        title="Entrepôts"
        url="/warehouses"
        icon={<Warehouse size={18} />}
      />

      <ExpendableLink
        title="Lots en stock"
        url="/stock-units"
        icon={<Boxes size={18} />}
      />

      <ExpendableLink
        title="Scanner un lot"
        url="/stock-scan"
        icon={<ScanLine size={18} />}
      />

      <ExpendableLink
        title="QR codes"
        url="/qr-codes"
        icon={<QrCode size={18} />}
      />
    </>
  );
};
